import React from 'react';
import Icon from '../AppIcon';
import PulsanteScanner from './PulsanteScanner';

/**
 * Campo di ricerca. Con `onScansiona` mostra dentro il campo il pulsante dello scanner:
 * il codice letto (o digitato nello scanner) viene passato a onScansiona(codice).
 * Il campo resta sempre digitabile a mano.
 */
const SearchInput = ({ value, onChange, placeholder = 'Cerca...', className = '', onScansiona, formatiScanner }) => (
  <div className={`relative flex-1 min-w-[200px] ${className}`}>
    <Icon name="Search" size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-primary/60" />
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`w-full bg-muted/40 border border-border/40 rounded-2xl py-2.5 pl-9 ${onScansiona ? 'pr-20' : 'pr-8'} outline-none focus:border-primary/60 focus:ring-2 focus:ring-primary/10 transition-all text-sm font-semibold text-foreground placeholder:text-muted-foreground/40 shadow-sm`}
    />
    {value && (
      <button
        type="button"
        onClick={() => onChange('')}
        aria-label="Cancella ricerca"
        className={`absolute ${onScansiona ? 'right-12' : 'right-3'} top-1/2 -translate-y-1/2 text-muted-foreground/40 hover:text-foreground transition-colors`}
      >
        <Icon name="X" size={13} />
      </button>
    )}
    {onScansiona && (
      <div className="absolute right-2 top-1/2 -translate-y-1/2">
        <PulsanteScanner variante="icona" onRilevato={onScansiona} formati={formatiScanner} />
      </div>
    )}
  </div>
);

export default SearchInput;
